export const getModalContainer = () => {
  const elem = document.querySelector('#modal')
  if (!elem) {
    throw Error('👻 Не определен елемент для вывода окна диалога')
  }
  return elem
}
